export enum TreatmentSubType {
  FlatOcclusalGuard = 1,
  OcclusalGuardwithBuccalTiltedAnteriorRamp = 2,
  Hollywood = 3,
  Enhanced = 4,
  Vigorous = 5,
  Softened = 6,
  Youthful = 7,
  Mature = 8,
  MichiganSplint = 9,
  FullCoverageAnteriorDeprogrammer = 10,
  Occlusalguardwithoutanteriorcoverage = 11,
  MattRobertsImproved = 34,
  DefaultVitaT6LRealViewLibrary = 35,
  GLBruxzir = 36,
  Crown = 37,
  Bridge = 38,
  NewDenture = 39,
  ImmediateDenture = 40,
  ReferenceDenture = 41,
  CopyDenture = 42,
  SameDayByAppointment = 43,
  NextBusinessDayByNoon = 44,
  ThreeBusinessDays = 45,
  RushHour = 46,
  TwoBusinessDays = 47,
  Inlay = 56,
  Onlay = 57,
  ShellTemp = 58,
  MarylandBridge = 59,
  RestorationMixed = 60,
  RushCrown = 61,
  RushBridge = 62,
  RushInlay = 63,
  RushOnlay = 64,
  RushShellTemp = 65,
  RushMarylandBridge = 66,
  RushRestorationMixed = 67,
  RushFlatOcclusalGuard = 68,
  RushOcclusalGuardWithAnteriorRamp = 69,
  RushMichiganSplint = 70,
  RushFullCoverageAnteriorDeprogrammer = 71,
  RushOcclusalGuardWithoutAnteriorCoverage = 72,
  OcclusalGuardWithLingualTiltedAnteriorRamp = 73,
  RushOcclusalGuardWithLingualTiltedAnteriorRamp = 74,
  ImplantRestorationCrown = 75,
  ImplantRestorationShellTemp = 76,
  ImplantRestorationBridge = 77,
  ImplantRestorationMixed = 78,
  RushImplantCrown = 79,
  RushImplantShellTemp = 80,
  RushImplantBridge = 81,
  RushImplantMixed = 82,
}
